import { SortDirection, SortType } from 'types/types';
import { InitialledScore } from 'pages/DownloadTeamWheel/scoreUtils';
import { ColourScoreWithPreference } from 'api';
import { WheelState } from 'pages/DownloadTeamWheel/hooks/useWheelContext';
import {
  buildColourOrder,
  compareByColourDominance,
} from 'pages/DownloadTeamWheel/TeamTable/teamTable.helper';

const useSorting = (
  scores: (InitialledScore & {
    organisationId: string;
    organisationName: string;
  })[],
  wheelState: WheelState,
) => {
  const { sortType, sortDirection, scoreType } = wheelState;

  const direction = sortDirection === SortDirection.ASCENDING ? 1 : -1;

  switch (sortType) {
    case SortType.NUMBER:
      return scores.sort((a, b) => direction * (a.index - b.index));

    case SortType.NAME: {
      return [...scores].sort(
        (a, b) => direction * a.fullName.localeCompare(b.fullName),
      );
    }
    case SortType.WHEEL_POSITION: {
      return [...scores].sort((a, b) => {
        const fa: any =
          scoreType === 'CONSCIOUS'
            ? a.wheelPositions.conscious
            : a.wheelPositions.lessConscious;
        const fb =
          scoreType === 'CONSCIOUS'
            ? b.wheelPositions.conscious
            : b.wheelPositions.lessConscious;
        return direction * (fa - fb);
      });
    }
    case SortType.COLOUR_PREF: {
      const isConsciousScore = scoreType === 'CONSCIOUS';
      return scores
        .map((row) => {
          const baseScores: ColourScoreWithPreference = isConsciousScore
            ? row.colourScores.conscious
            : row.colourScores.lessConscious;

          const preferred = baseScores.preferred ?? [];

          return {
            ...row,
            colourOrderPref: buildColourOrder(baseScores),
            prefCount: preferred.length,
          };
        })
        .sort(compareByColourDominance(direction, isConsciousScore));
    }
    case SortType.ORGANISATION: {
      return [...scores].sort((a, b) => {
        if (a.organisationName === b.organisationName) {
          return a.fullName.localeCompare(b.fullName);
        }
        return direction * a.organisationName.localeCompare(b.organisationName);
      });
    }
    default:
      return scores;
  }
};
export default useSorting;
